import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import { RootState } from "../../store";
import { del, deleteReqBody, get, put } from "../../../services/API/ApiClient";
import { openErrorNotification, openNotification } from "../../../components/Template/NotificationComponent";
export const getOrganizationDetail = createAsyncThunk<any, any, { state: RootState }>("transcribe/getTenantDetail", async (args, { getState, dispatch, rejectWithValue }) => {
  try {
    const response = await get(`/tenants/${args}`, "Transcribe");
    return response.data;
  } catch (e) {
    return rejectWithValue(e);
  }
});
export const getUnassignedUsers = createAsyncThunk<any, any, { state: RootState }>("transcribe/getUnassignedUsers", async (args, { getState, dispatch, rejectWithValue }) => {
  try {
    const response = await get(`/tenants/${args}/unassigned-users`, "Transcribe");
    const unassignedUsers = response.data.map((user: any) => {
      return {
        value: user.idUser,
        label: user.username,
      };
    });
    return unassignedUsers;
  } catch (e) {
    return rejectWithValue(e);
  }
});

export const assignUsers = createAsyncThunk<any, any, { state: RootState }>("transcribe/assignUsers", async (args, { getState, dispatch, rejectWithValue }) => {
  try {
    const response = await put(`/tenants/assign-users`, "Transcribe", args);

    openNotification("Assign User", "User assigned successfully ", "top");
    return response.data;
  } catch (e) {
    openErrorNotification("Assign User", "Error assigning user, please try again.", "top");
    throw e;
  }
});
export const unassignUser = createAsyncThunk<any, any, { state: RootState }>("transcribe/unassignUser", async (args, { getState, dispatch, rejectWithValue }) => {
  try {
    const response = await deleteReqBody(`/tenants/unassign-users`, "Transcribe", args);
    openNotification("Unassign User", "User unassigned successfully ", "top");
    return response.data;
  } catch (e) {
    openErrorNotification("Unassign User", "Error unassigning user, please try again.", "top");
    throw e;
  }
});

export const resetOrganizationDetailPage = createAction("transcribe/resetOrganizationDetailPage");
//Modal
export const openAssignUserModal = createAction("transcribe/openAssignUserModal");
export const closeAssignUserModal = createAction("transcribe/closeAssignUserModal");

export const openDeleteUserConfirmationModal = createAction("transcribe/openDeleteUserConfirmationModal");
export const closeDeleteUserConfirmationModal = createAction("transcribe/closeDeleteUserConfirmationModal");
export const openDeleteTemplateConfirmationModal = createAction("transcribe/openDeleteTemplateConfirmationModal");
export const closeDeleteTemplateConfirmationModal = createAction("transcribe/closeDeleteTemplateConfirmationModal");
